<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="breakpoints.lgAndUp ? '40%' : '90%'"
    top="10vh"
    custom-class="custom-scrollable"
  >
    <div class="font-normal pb-2">
      <div class="dialog-header pb-5">
        <div class="text-xl mt-4 font-bold text-root-2 flex justify-start">
          Withdrawal Methods
        </div>
        <span class="text-gray-40 flex justify-start mb-6">
          Add Wire transfer account method</span
        >
      </div>
      <div class="font-normal mb-4">
        <el-form
          label-position="top"
          :model="withdrawalForm"
          ref="withdrawalForm"
          :rules="rules"
          label-width="80px"
          size="normal"
        >
          <el-form-item label="Full Name" prop="fullName">
            <el-input
              class="w-full"
              v-model="withdrawalForm.fullName"
              placeholder="Enter full name"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="Country" prop="country">
            <el-select
              class="w-full"
              filterable
              remote
              v-model="withdrawalForm.country"
              placeholder="Search Country"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="(country, index) in options"
                :key="index"
                :label="country.name"
                :value="country.code2"
              >
                {{ country.name }}</el-option
              >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-select>
          </el-form-item>
          <el-form-item label="Bank Name" prop="bankName">
            <el-input
              class="w-full"
              v-model="withdrawalForm.bankName"
              placeholder="Enter Bank Name"
            ></el-input>
          </el-form-item>
          <el-form-item label="Currency" prop="currency">
            <el-select
              class="w-full"
              v-model="withdrawalForm.currency"
              placeholder="Select Currency"
            >
              <el-option
                v-for="item in currency"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Account Number" prop="accountNumber">
            <el-input
              class="w-full"
              v-model.trim="withdrawalForm.accountNumber"
              placeholder="Enter Account number"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            v-if="!isAmericanDetails"
            label="Swift Code"
            prop="swiftCode"
          >
            <el-input
              class="w-full"
              v-model.trim="withdrawalForm.swiftCode"
              placeholder="Enter Swift Code"
            >
            </el-input>
          </el-form-item>

          <el-form-item v-if="!isAmericanDetails" label="City" prop="city">
            <el-input
              class="w-full"
              v-model="withdrawalForm.city"
              placeholder="Enter City"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="!isAmericanDetails"
            label="Bank Address"
            prop="bankAddress"
          >
            <el-input
              class="w-full"
              v-model="withdrawalForm.bankAddress"
              placeholder="Enter Address"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="!isAmericanDetails"
            label="Postal Code"
            prop="postalCode"
          >
            <el-input
              class="w-full"
              v-model.trim="withdrawalForm.postalCode"
              placeholder="Enter Postal Code"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="isAmericanDetails"
            label="Routing number"
            prop="routingNumber"
          >
            <el-input
              class="w-full"
              v-model.trim="withdrawalForm.routingNumber"
              placeholder="Enter Routing number "
            >
            </el-input>
          </el-form-item>
          <div
            class="pb-4"
            v-if="!isAmericanDetails && !withdrawalCurrencyIsLocal"
          >
            <p
              class="font-bold text-xs mt-10 mb-2 userDetails"
              id="userDetails"
            >
              Intermediary Bank
            </p>
            <hr />
            <div class="italic font-normal text-xs pt-4 pb-2">
              Do you want to utilise an intermediary bank?
            </div>
            <el-checkbox
              class="pb-2"
              v-model="showIntermediaryBankDetails"
            ></el-checkbox>
            <div v-if="showIntermediaryBankDetails">
              <el-form-item
                label="Intermediary Bank Name"
                prop="intermediaryBankName"
              >
                <el-input
                  class="w-full"
                  v-model="withdrawalForm.intermediaryBankName"
                  placeholder="Enter Intermediary Bank Name"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="Intermediary Bank Reference"
                prop="intermediaryBankReference"
              >
                <el-input
                  class="w-full"
                  v-model="withdrawalForm.intermediaryBankReference"
                  placeholder="Enter Intermediary Bank Reference"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="Enter Intermediary Bank Swift Code"
                prop="intermediaryBankSwiftCode"
              >
                <el-input
                  class="w-full"
                  v-model.trim="withdrawalForm.intermediaryBankSwiftCode"
                  placeholder="Enter Intermediary Bank Swift Code"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="Intermediary Bank Address"
                prop="intermediaryBankAddress"
              >
                <el-input
                  class="w-full"
                  v-model="withdrawalForm.intermediaryBankAddress"
                  placeholder="Enter Intermediary Bank Address"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <o-button @click="validateForm('withdrawalForm')">Add</o-button>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ALL_COUNTRIES, CURRENCY } from '@/utils/constants.js'
import {
  ValidateInput,
  ValidateRoutingNumber,
  ValidateSwiftCode,
  ValidateText,
  ValidateSingleSpace
} from '@/utils/helpers.js'
import breakpoints from '@/utils/breakpoints.js'
import localDeposit from '@/mixins/localDeposit.js'
export default {
  mixins: [localDeposit],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      showIntermediaryBankDetails: false,
      allCountries: ALL_COUNTRIES,
      currency: CURRENCY,
      loading: false,
      options: [],
      countries: [],
      withdrawalForm: {
        fullName: '',
        country: '',
        currency: '',
        accountNumber: '',
        city: '',
        bankName: '',
        postalCode: '',
        bankAddress: '',
        swiftCode: '',
        routingNumber: '',
        intermediaryBankReference: '',
        intermediaryBankAddress: '',
        intermediaryBankName: '',
        intermediaryBankSwiftCode: ''
      },
      rules: {
        fullName: [
          {
            required: true,
            message: 'Please input your full Name',
            trigger: 'blur'
          },
          { min: 3, message: 'Length should be at least 3 ', trigger: 'blur' },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        country: [
          {
            required: true,
            message: 'Please select a country',
            trigger: 'blur'
          }
        ],
        currency: [
          {
            required: true,
            message: 'Please select a currency',
            trigger: 'blur'
          }
        ],
        swiftCode: [
          {
            required: true,
            message: 'Please input swift code',
            trigger: ['blur', 'change']
          },
          {
            min: 8,
            max: 11,
            message: 'Length should be between 8 to 11 characters ',
            trigger: ['blur', 'change']
          },
          { validator: ValidateSwiftCode, trigger: ['blur', 'change'] }
        ],
        accountNumber: [
          {
            required: true,
            message: 'Please enter a valid account number',
            trigger: 'blur'
          },
          { validator: ValidateSingleSpace, trigger: ['blur', 'change'] }
        ],
        intermediaryBankSwiftCode: [
          {
            required: true,
            message: 'Please input swift code',
            trigger: ['blur', 'change']
          },
          {
            min: 8,
            max: 11,
            message: 'Length should be between 8 to 11 characters ',
            trigger: ['blur', 'change']
          },
          { validator: ValidateSwiftCode, trigger: ['blur', 'change'] }
        ],
        intermediaryBankName: [
          {
            required: true,
            message: 'Please select intermediary bank name',
            trigger: 'blur'
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        intermediaryBankAddress: [
          {
            required: true,
            message: 'Please select intermediary bank address',
            trigger: 'blur'
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        intermediaryBankReference: [
          {
            required: true,
            message: 'Please select intermediary bank reference',
            trigger: 'blur'
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        bankAddress: [
          {
            required: true,
            message: 'Please enter a bank address',
            trigger: 'blur'
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        city: [
          {
            required: true,
            message: 'Please enter a bank city',
            trigger: 'blur'
          },
          { validator: ValidateText, trigger: ['blur', 'change'] }
        ],
        bankName: [
          {
            required: true,
            message: 'Please enter a bank name',
            trigger: 'blur'
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        routingNumber: [
          {
            required: true,
            message: 'Please enter a routing number',
            trigger: 'blur'
          },
          {
            min: 9,
            max: 9,
            message: 'Length should be 9 characters ',
            trigger: ['blur', 'change']
          },
          { validator: ValidateRoutingNumber, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.allCountries.filter((item) => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 100)
      } else {
        this.options = []
      }
    },
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const intermediaryDetails = this.withdrawalForm.intermediaryBankName
            ? {
                reference: this.withdrawalForm.intermediaryBankReference,
                bankAddress: this.withdrawalForm.intermediaryBankAddress,
                bankName: this.withdrawalForm.intermediaryBankName,
                swiftCode: this.withdrawalForm.intermediaryBankSwiftCode
              }
            : null
          const details = this.withdrawalForm
          delete details.intermediaryBankReference
          delete details.intermediaryBankAddress
          delete details.intermediaryBankName
          delete details.intermediaryBankSwiftCode
          details.isWithinUs = this.isAmericanDetails ? 'yes' : 'no'
          this.$emit('closeDialog')
          this.$emit('storeBankInfo', {
            details,
            intermediaryDetails
          })
          this.$emit('verifyUser')
        } else {
          this.$notify.error({
            title: 'Invalid Details',
            message: 'Please fill the required details',
            position: 'top-right'
          })
        }
      })
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    isAmericanDetails () {
      return (
        this.withdrawalForm.country === 'US' || !this.withdrawalForm.country
      )
    }
  },
  components: {}
}
</script>

<style scoped>
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-form-item__label {
  margin-bottom: 3px;
  line-height: 16px;
}

>>> .el-input__inner {
  border-radius: 8px;
  border-color: #c7c8d2;
  height: 45px;
  font-weight: 400 !important;
  font-size: 14px !important;
}
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
